import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    isLoading: false,
    is_failure: false,
}

const orderHistorySlice = createSlice({
    name:"orderHistory",
    initialState: initialState,
    reducers: {
        getOrderHistory(state, action){
            return {
                isLoading: true,
                is_failure: false,
            }
        },
        getOrderHistorySuccess(state, action){
            return {
                isLoading: false,
                is_failure: false,
                ...action.payload,
            }
        },
        getOrderHistoryFailure(state, action){
            return {
                isLoading: false,
                is_failure: true,
            }
        },
        cleanOrderHistory(state, action){
            return{
                isLoading: false,
                is_failure: false,
            }
        }
    }
})

export const { 
    getOrderHistory, 
    getOrderHistoryFailure, 
    getOrderHistorySuccess,
    cleanOrderHistory,
} = orderHistorySlice.actions

export default orderHistorySlice.reducer